import { checkPermissions } from "@/graphql/schemas/shared/permissions/permissions"

export const queryCheckPermission = {
  async checkPermission(parent, args, context, info) {
    const { user } = context
    let { domainObject, operation } = args

    try {
      await checkPermissions({
        user,
        domainObject: domainObject,
        operation: operation,
      })
      return { permissionGranted: true }
    } catch (e) {
      console.warn(e)
      return { permissionGranted: false }
    }
  },
}
